import { Illustration } from '@doxyme/ui/components/foundations';
import { Icon } from '@doxyme/icons';
import { UpsellCard } from '../../../upgrade/upsellCard';

import type { JSX } from 'react';

export const InviteViaEmailUpsellCard = (): JSX.Element => (
  <UpsellCard
    image={<Illustration.Mail />}
    content={[
      {
        icon: <Icon.Padlock type='filled' />,
        title: 'inviteViaEmail.maintainYourPrivacyTitle',
        description: 'inviteViaEmail.maintainYourPrivacyDescription',
      },
      {
        icon: <Icon.Mail type='filled' />,
        title: 'inviteViaEmail.saveTimeTitle',
        description: 'inviteViaEmail.saveTimeDescription',
      },
    ]}
  />
);
